import type { User } from '../states.d.ts';


export const userState: Partial<User> = {};
